export const USE_ACTION_TYPE = {
  SHOW_ALERT_INAPP: 'SHOW_ALERT_INAPP',
  SHOW_ALERT_USE_PRODUCT: 'SHOW_ALERT_USE_PRODUCT',
  USE_COUPON: 'USE_COUPON',
  SHOW_POPUP_REGIST_RECURRING: 'SHOW_POPUP_REGIST_RECURRING',
}

export const normalizeCheckUseAction = (rawData) => {
  if (!rawData) {
    return undefined
  }

  return {
    actionType: USE_ACTION_TYPE[rawData?.action_type],
  }
}
